export const REQUEST_USERS_PENDING = "REQUEST_USERS_PENDING";
export const REQUEST_USERS_SUCCESS = "REQUEST_USERS_SUCCESS";
export const REQUEST_USERS_FAILED = "REQUEST_USERS_FAILED";
export const REQUEST_TOP_USERS_PENDING = "REQUEST_USERS_PENDING";
export const REQUEST_TOP_USERS_SUCCESS = "REQUEST_USERS_SUCCESS";
export const REQUEST_TOP_USERS_FAILED = "REQUEST_USERS_FAILED";
export const REQUEST_FOLLOWERS_PENDING = "REQUEST_FOLLOWERS_PENDING";
export const REQUEST_FOLLOWERS_SUCCESS = "REQUEST_FOLLOWERS_SUCCESS";
export const REQUEST_FOLLOWERS_FAILED = "REQUEST_FOLLOWERS_FAILED";
export const REQUEST_CUSTOMIZE_PENDING = "REQUEST_CUSTOMIZE_PENDING";
export const REQUEST_CUSTOMIZE_SUCCESS = "REQUEST_CUSTOMIZE_SUCCESS";
export const REQUEST_CUSTOMIZE_FAILED = "REQUEST_CUSTOMIZE_FAILED";
export const COLOR_BUTTON = "COLOR_BUTTON";
export const REQUEST_COLOR_BUTTON_PENDING = "REQUEST_COLOR_BUTTON_PENDING";
export const REQUEST_COLOR_BUTTON_SUCCESS = "REQUEST_COLOR_BUTTON_SUCCESS";
export const REQUEST_COLOR_BUTTON_FAILED = "REQUEST_COLOR_BUTTON_FAILED";
export const COLOR_BACKGROUND = "COLOR_BACKGROUND";
export const REQUEST_COLOR_BACKGROUND_PENDING = "REQUEST_COLOR_BACKGROUND_PENDING";
export const REQUEST_COLOR_BACKGROUND_SUCCESS = "REQUEST_COLOR_BACKGROUND_SUCCESS";
export const REQUEST_COLOR_BACKGROUND_FAILED = "REQUEST_COLOR_BACKGROUND_FAILED";
export const FONT_SIZE = "FONT_SIZE";
export const REQUEST_FONT_SIZE_PENDING = "REQUEST_FONT_SIZE_PENDING";
export const REQUEST_FONT_SIZE_SUCCESS = "REQUEST_FONT_SIZE_SUCCESS";
export const REQUEST_FONT_SIZE_FAILED = "REQUEST_FONT_SIZE_FAILED";
export const REQUEST_ROOM_PENDING = "REQUEST_ROOM_PENDING";
export const REQUEST_ROOM_SUCCESS = "REQUEST_ROOM_SUCCESS";
export const REQUEST_ROOM_FAILED = "REQUEST_ROOM_FAILED";
export const SECOND_USER = "SECOND_USER";
export const REQUEST_SECOND_USER_PENDING = "REQUEST_SECOND_USER_PENDING";
export const REQUEST_SECOND_USER_SUCCESS = "REQUEST_SECOND_USER_SUCCESS";
export const REQUEST_SECOND_USER_FAILED = "REQUEST_SECOND_USER_FAILED";
export const ROOM_MESSAGES = "ROOM_MESSAGES";
export const REQUEST_ROOM_MESSAGES_PENDING = "REQUEST_ROOM_MESSAGES_PENDING";
export const REQUEST_ROOM_MESSAGES_SUCCESS = "REQUEST_ROOM_MESSAGES_SUCCESS";
export const REQUEST_ROOM_MESSAGES_FAILED = "REQUEST_ROOM_MESSAGES_FAILED";
export const SECTION_TITLE = "SECTION_TITLE";
export const REQUEST_USER_PENDING = "REQUEST_USER_PENDING";
export const REQUEST_USER_SUCCESS = "REQUEST_USER_SUCCESS";
export const REQUEST_USER_FAILED = "REQUEST_USER_FAILED";
export const EDIT_PROFILE_FIRSTNAME = "EDIT_PROFILE_FIRSTNAME";
export const EDIT_PROFILE_LASTNAME = "EDIT_PROFILE_LASTNAME";
export const EDIT_PROFILE_USERNAME = "EDIT_PROFILE_USERNAME";
export const EDIT_PROFILE_DESCRIPTION = "EDIT_PROFILE_DESCRIPTION";
export const EDIT_PROFILE_BIRTHDAY = "EDIT_PROFILE_BIRTHDAY";
export const REQUEST_HOME_POSTS_PENDING = "REQUEST_HOME_POSTS_PENDING";
export const REQUEST_HOME_POSTS_SUCCESS = "REQUEST_HOME_POSTS_SUCCESS";
export const REQUEST_HOME_POSTS_FAILED = "REQUEST_HOME_POSTS_FAILED";
export const DIALOG_TWEET_SHOW = "DIALOG_TWEET_SHOW";
export const DIALOG_CUSTOMIZE_SHOW = "DIALOG_CUSTOMIZE_SHOW";
export const BACK_BUTTON_SHOW = "BACK_BUTTON_SHOW";
export const ROOMS_SECOND_USER_ID_ARRAY = "ROOMS_SECOND_USER_ID_ARRAY";